import { css } from '@emotion/react';
import { Typography } from '@mui/material';
import { colors } from '../../../../../theme/colors';
import { PANEL_LIST } from '../constants';
import { TearsheetPanelType } from '../types';
import { PanelCard } from './PanelCard';

const paletteContainerStyle = css`
  width: 280px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  background: white;
  border-right: 1px solid ${colors.neutral[20]};
  overflow-y: auto;
`;

const headerStyle = css`
  padding-bottom: 0.5rem;
  border-bottom: 1px solid ${colors.neutral[10]};
`;

const panelListStyle = css`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

interface PanelPaletteProps {
  usedPanels: Set<TearsheetPanelType>;
}

export function PanelPalette({ usedPanels }: PanelPaletteProps) {
  return (
    <div css={paletteContainerStyle}>
      <div css={headerStyle}>
        <Typography variant='subtitle1' fontWeight={600}>
          Available Panels
        </Typography>
        <Typography variant='caption' color='text.secondary'>
          Drag panels to the canvas
        </Typography>
      </div>
      <div css={panelListStyle}>
        {PANEL_LIST.map((panel) => (
          <PanelCard key={panel.type} panel={panel} isUsed={usedPanels.has(panel.type)} />
        ))}
      </div>
    </div>
  );
}
